module.exports = __webpack_public_path__ + "img/702.f4afda79.jpg";